import { useEffect, useState } from "react";
import UploadImages from "./upload-images";
import { useTranslation } from "react-i18next";
import { PropertyReport } from "../../Models/PropertyReport";
import MorePhotos from "./more-photos";

const HeroPhotos: React.FunctionComponent<{ errors: any, property: PropertyReport, images: any[], OnChangeCover: any, OnChangeHeroPhotos: any, onImagesAdded: any }> = (props) => {

    const { t } = useTranslation();
    const MAX_SELECTED = 6;

    // Toujours limiter à 6 images max
    const initialImages = (props.images || []).slice(0, MAX_SELECTED);
    const [imagesValue, setImagesValue] = useState<any[]>(initialImages);
    // Initialize selectedIndexes avec les premières images dispo
    const [selectedIndexes, setSelectedIndexes] = useState<number[]>(
        initialImages.map((_, idx) => idx)
    );

    useEffect(() => {
        setImagesValue((props.images || []).slice(0, MAX_SELECTED))
        setSelectedIndexes(initialImages.map((_, idx) => idx))
    }, [props.images])


    const handleUploadImages = (newImageSrc: any, index: number) => {
        const updatedImages = [...imagesValue];

        // S'assurer que le tableau a la bonne taille
        while (updatedImages.length <= index) {
            updatedImages.push("");
        }

        // Placer l'image à l'index spécifique
        updatedImages[index] = newImageSrc[0].src;

        setImagesValue(updatedImages);

        // Automatiquement sélectionner cette image si elle n'est pas déjà sélectionnée
        let newSelectedIndexes = [...selectedIndexes];
        if (!newSelectedIndexes.includes(index) && newSelectedIndexes.length < MAX_SELECTED) {
            newSelectedIndexes.push(index);
        }

        setSelectedIndexes(newSelectedIndexes);

        const selectedImages = newSelectedIndexes.map(idx => updatedImages[idx]).filter(img => img);
        props.OnChangeHeroPhotos(selectedImages);
    };

    const UploadImageHandler = (images: any) => {
        props.OnChangeCover(images[0].src);
    };

    const handleCheckboxChange = (index: number) => {
        let newSelectedIndexes;
        if (selectedIndexes.includes(index)) {
            newSelectedIndexes = selectedIndexes.filter(i => i !== index);
        } else {
            if (selectedIndexes.length < MAX_SELECTED) {
                newSelectedIndexes = [...selectedIndexes, index];
            } else {
                newSelectedIndexes = selectedIndexes;
            }
        }
        setSelectedIndexes(newSelectedIndexes);

        const selectedImages = newSelectedIndexes.map(idx => imagesValue[idx]).filter(img => img);
        props.OnChangeHeroPhotos(selectedImages);
    };

    return (
        <div className="mb-3 ">
            <div className={`card border-16 padd-20 ${props.errors.images ? 'input-error' : ''}`}>
                <div className="d-flex justify-content-center">
                    <div className="title-18 hero-title">
                        <i className="fa-solid fa-circle-exclamation marg-right-10" style={{ color: '#eb4799' }}></i>
                        Select the next best 6 photos
                    </div>
                </div>
                <div className="hero-photos-container">
                    {/* Image principale */}
                    <div className={`hero-main-image  ${props.errors.heroImageUrl ? 'input-error' : ''}`}>
                        <div className="hero-image-main">
                            <UploadImages
                                errors={false}
                                key="main"
                                OnUploadImages={UploadImageHandler}
                                image={props.property.heroSection?.heroImageUrl}
                                multipleImgs={false}
                                height="height-562"
                                label={t("report.Upload Photo")}
                                listImages={props.property.listingImages || []}
                            />
                        </div>
                    </div>

                    {/* Images latérales (3 images) */}
                    <div className="hero-side-images">
                        {Array.from({ length: 3 }).map((_, index) => {
                            const img = imagesValue[index] || "";
                            const isChecked = selectedIndexes.includes(index);
                            const isDisabled = !isChecked && selectedIndexes.length >= MAX_SELECTED;
                            const hasImage = img !== "";

                            return (
                                <div key={index} className={`hero-image-item hero-image-side border-8 ${!hasImage ? 'hero-upload-slot' : ''}`}>
                                    {hasImage && (
                                        <div className="hero-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={isChecked}
                                                disabled={isDisabled}
                                                onChange={() => handleCheckboxChange(index)}
                                            />
                                        </div>
                                    )}
                                    <UploadImages
                                        errors={false}
                                        key={index}
                                        OnUploadImages={(newSrc: string) => handleUploadImages(newSrc, index)}
                                        image={img}
                                        listImages={props.property.listingImages || []}
                                        multipleImgs={false}
                                        height="h-100"
                                        label={t("report.Upload Photo")}
                                    />
                                </div>
                            );
                        })}
                    </div>

                    {/* Images du bas (3 images) */}
                    <div className="hero-bottom-images">
                        {Array.from({ length: 3 }).map((_, localIndex) => {
                            const index = localIndex + 3; // Index 3, 4, 5
                            const img = imagesValue[index] || "";
                            const isChecked = selectedIndexes.includes(index);
                            const isDisabled = !isChecked && selectedIndexes.length >= MAX_SELECTED;
                            const hasImage = img !== "";

                            return (
                                <div key={index} className={`hero-image-item hero-image-bottom border-8${!hasImage ? 'hero-upload-slot' : ''}`}>
                                    {hasImage && (
                                        <div className="hero-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={isChecked}
                                                disabled={isDisabled}
                                                onChange={() => handleCheckboxChange(index)}
                                            />
                                        </div>
                                    )}
                                    <UploadImages
                                        errors={false}
                                        key={index}
                                        OnUploadImages={(newSrc: string) => handleUploadImages(newSrc, index)}
                                        image={img}
                                        multipleImgs={false}
                                        listImages={props.property.listingImages || []}
                                        height="h-100"
                                        label={t("report.Upload Photo")}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="text-center mt-2">
                   <MorePhotos listImages={props.property.listingImages || []} onImagesAdded={props.onImagesAdded} />
                </div>
            </div>
        </div>
    );
};


export default HeroPhotos;